export interface FooterMenuItemConfig {
  id: string
  external?: boolean
}

export interface FooterMenuSectionConfig {
  id: string
  items: FooterMenuItemConfig[]
}

export const footerMenu: FooterMenuSectionConfig[] = [
  {
    id: 'companies',
    items: [
      { id: 'help' },
      // { id: 'about_us' },
      { id: 'user_agreements' },
      { id: 'privacy_policy' },
      // { id: 'cookie_policy' },
      { id: 'contacts' }
    ]
  },
  {
    id: 'social',
    items: [
      { id: 'telegram', external: true },
      { id: 'facebook', external: true },
      { id: 'youtube', external: true }
    ]
  }
]
